<template>
	<div class="relative aspect-square rounded-full">
		<span class="flex h-full w-full overflow-hidden rounded-full">
			<img v-if="selectedImage" class="h-full w-full object-cover" alt="" :src="selectedImage" />
			<svg
				v-else
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 100 100"
				class="h-full w-full font-black tracking-[-0.15rem]"
			>
				<rect width="100" height="100" :fill="selectedColor" rx="50" />
				<text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="36">
					{{ selectedLetters }}
				</text>
			</svg>
		</span>
		<span
			v-if="!hideStatusIndicator && isOnline"
			class="border-white bg-green-500 absolute bottom-0 end-0 z-[1] aspect-square w-[26%] rounded-full border-2"
		></span>
	</div>
</template>

<script setup lang="ts">
import { convertObjectToUser, isUserOnline, type ConvertObjectToUserType, type User } from "~/models/user"

const app = useNuxtApp()

const props = defineProps<{
	name?: string
	color?: string
	image?: string
	target?: unknown
	type?: ConvertObjectToUserType
	me?: boolean
	hideStatusIndicator?: boolean
}>()

const avatarColors = [
	"#D32F2F",
	"#C2185B",
	"#7B1FA2",
	"#512DA8",
	"#303F9F",
	"#1976D2",
	"#0288D1",
	"#0097A7",
	"#00796B",
	"#388E3C",
	"#689F38",
	"#AFB42B",
	"#FBC02D",
	"#FFA000",
	"#F57C00",
	"#E64A19",
	"#5D4037",
	"#455A64",
	"#212121",
	"#37474F"
]

const user = computed<User | null>(() => {
	return props.type ? convertObjectToUser(props.target, props.type, props.me) : null
})

const selectedImage = computed(() => {
	if (props.image) return props.image
	return user.value?.image_id ? app.$config.public.baseUrl + user.value.image_thumb1 : null
})

const selectedName = computed(() => {
	if (props.name) return props.name || ""
	return user.value
		? [user.value.firstname, user.value.lastname].filter((v) => v).join(" ") ||
				user.value.staff_number_with_prefix ||
				""
		: ""
})

const selectedLetters = computed(() => {
	return selectedName.value
		?.split?.(" ")
		.map?.((v) => v[0])
		.filter?.((v) => v)
		.map?.((v) => v.toUpperCase())
		.join?.(" ")
})

const selectedColor = computed(() =>
	props.color
		? props.color
		: avatarColors[
				(selectedName.value
					?.split?.("")
					?.map?.((v) => v.charCodeAt(0))
					?.reduce?.((a, b) => a + b, 0) || 0) % avatarColors.length
			]
)

const isOnline = computed(() => isUserOnline(user.value))
</script>
